export const DASHBOARD_API_URL = (
  import.meta.env.VITE_DASHBOARD_API_URL ?? "http://localhost:3001"
).replace(/\/$/, "");

// Unset locally and on any stage whose config carries no SENTRY_DSN_DASHBOARD,
// which is what turns the browser client off (lib/sentry.ts).
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;
